import { ApiBase } from "@/api/ApiBase";

export interface GrupoArtigoResumo {
  id: number;
  nome: string;
  codigo: string;
}

export interface CategoriaSimples {
  id: number;
  nome: string;
}

export interface ImpostoResumo {
  id: number;
  nome: string;
  sigla: string;
  taxa: number;
}

export interface IsencaoResumo {
  id: number;
  motivo: string;
}

export interface FornecedorSimples {
  id: number;
  nome: string;
}

export interface EssencialArtigo {
  fornecedores: FornecedorSimples[];
  grupoArtigos: GrupoArtigoResumo[];
  categorias: CategoriaSimples[];
  impostos: ImpostoResumo[];
  isencoes: IsencaoResumo[];
}

export const GRUPO_ARTIGO_CODIGO_PRODUTO = "TB";

export interface PaisResumo {
  id: number;
  nome: string;
}

export interface ContaBancariaResumo {
  id: number;
  codigo: string;
  titular: string;
  numero: string;
  iban: string;
  estado: "Activo" | "Inactivo";
  bancoNome: string;
  bancoSigla: string;
}

export interface EstabelecimentoParaFacturacao {
  id: number;
  endereco: string;
  codigo: string;
  numero: string;
  nome: string;
}

export interface EssencialFacturacao {
  contasBancarias: ContaBancariaResumo[];
  estabelecimentos: EstabelecimentoParaFacturacao[];
}

/** Todos os campos são opcionais: se o código do estabelecimento não for
 * reconhecido, a API devolve um objecto vazio (nenhuma chave presente). */
export interface EssencialMainStock {
  totalArtigosStock?: number;
  totalArtigosBaixoStock?: number;
  totalArtigosZeroStock?: number;
  totalArtigosEntradasHojeStock?: number;
  totalArtigosSaidasHojeStock?: number;
}

export class AuxiliarApi extends ApiBase {
  essencialToArtigo(): Promise<EssencialArtigo> {
    return this.http.put<EssencialArtigo>(
      "/api/facturacao/info-auxiliar/essencial-to-artigo",
    );
  }

  essencialToFacturacao(): Promise<EssencialFacturacao> {
    return this.http.put<EssencialFacturacao>(
      "/api/facturacao/info-auxiliar/essencial-to-facturacao",
    );
  }

  essencialToMainStock(codigo: string): Promise<EssencialMainStock> {
    return this.http.put<EssencialMainStock>(
      `/api/facturacao/info-auxiliar/essencial-to-main-stock/${codigo}`,
    );
  }

  todosPaises(): Promise<PaisResumo[]> {
    return this.http.put<PaisResumo[]>("/api/facturacao/info-auxiliar/paises");
  }
}
